import COUNTRIES from '../countries.translations'

import translations from './tungsten.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/tungsten'

export const tungsten: Metal = {
  id: 35,
  slug: 'tungsten',
  name: t.name,
  symbol: 'W',
  mines: [
    {
      name: 'Ganzhou (China, Jiangxi — "Tungsten Capital"): Pangushan, Shizhuyuan',
      region: t.mine0Region,
      slug: 'ganzhou',
      coordinates: [114.93, 25.83],
    },
    {
      name: 'Núi Pháo (Vietnam, Ha Giang, Masan Resources — largest mine outside China)',
      region: t.mine1Region,
      slug: 'nui-phao',
      coordinates: [105.63, 21.83],
    },
    {
      name: 'Cantung (Canada, NWT, Almonty)',
      region: t.mine2Region,
      slug: 'cantung',
      coordinates: [-128.22, 61.93],
    },
    {
      name: 'Panasqueira (Portugal, Almonty)',
      region: t.mine3Region,
      slug: 'panasqueira',
      coordinates: [-7.77, 40.07],
    },
    {
      name: 'Mittersill (Austria, Wolfram Bergbau)',
      region: t.mine4Region,
      slug: 'mittersill',
      coordinates: [12.48, 47.28],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 83 },
    { name: COUNTRIES.vietnam, percent: 4.2 },
    { name: COUNTRIES.russia, percent: 2.5 },
    { name: COUNTRIES.northKorea, percent: 2.1 },
    { name: COUNTRIES.bolivia, percent: 2 },
  ],
  // Conflict-minerals companions named on the sheet.
  related: ['gold', 'tin', 'tantalum'],
  content: {
    smartphone: {
      quantityScore: 3,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 3, ...t.supplyRisk },
    recycling: { score: 4, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
      secondBento: [
        {
          src: `${dir}/03.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
